import React from "react";
import { Route } from "react-router-dom";

import App from ".";
import SignIn from "../Pages/Authentication/SignIn/SignIn1";
import SignInOtp from "../Pages/Authentication/SignIn/SignInOtp";
import RegisterForm2 from "../Pages/Authentication/SignIn/RegisterForm2";
import Loadable from "react-loadable";
import LoadingSkeleton from "./layout/Indicator/loading-skeleton";
import NotFound from "../Pages/Authentication/NotFound";

import SamlRedirect from "../Pages/Authentication/SamlRedirect";
import VerifyUserEmail from "../Pages/Authentication/VerifyUserEmail";
import Terms from "../Pages/Other/Terms";
import Policy from "../Pages/Other/Policy";
import HelpService from "../Pages/Other/HelpService";
import FAQs from "../Pages/Other/FAQs";
import RequireAuth from "./components/RequireAuth";
// import RequestForm from "../Pages/Request";

const CompletedQRCodeRequest = React.lazy(() => import("../Pages/Request/completedQRCodeRequest"));

const AdminLayout = Loadable({
    loader: () => import("./layout/AdminLayout"),
    loading: LoadingSkeleton,
});

const router = (
    <Route path="/" element={<App />} >

        <Route path="login" name="Signin 1" element={<SignIn />} ></Route>
        <Route path="dealer-registration" element={<RegisterForm2 />} />

        <Route path="req-qr/create/login" name="Signin QR" element={<SignIn />} />
        <Route path="req-qr/edit/login" name="Signin QR" element={<SignIn />} />
        <Route path="req-qr/login" name="Signin QR" element={<SignInOtp />} />

        <Route path="/terms" element={<Terms />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/privacypolicy" element={<Policy />} />
        <Route path="helpService" element={<HelpService />} />

        {/* <Route path="changepassword" element={<RequireAuth> <ChangePassword />  </RequireAuth>} /> */}
        <Route path="completedQRCodeRequest" name="Completed QR Code requesst" element={<CompletedQRCodeRequest />} />
        <Route path="home/portal-account-verify" element={<VerifyUserEmail />} />
        <Route path="home/reset-password" element={<VerifyUserEmail />} />
        <Route path="home/samlredirect/client/:clientId/portal/:portalId" name="Saml Redirect" element={<SamlRedirect />} />
        <Route path="dashboard/*" element={<RequireAuth> <AdminLayout />  </RequireAuth>} >
            {/* <Route path="requests/:requestId" element={<RequestForm />} /> */}
            {/* <Route path="noaccess" element={<NoAccess />} /> */}
            {/* <Route path="requests/detail/:requestId" element={<CardRequestDetail />} /> */}
        </Route>

        <Route path="/" element={<RequireAuth><SignIn></SignIn></RequireAuth>} />
        <Route path="notfound" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
    </Route>
);

export default router;
